<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="landownerForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="landowner" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                landownerForm: () => import('../forms/LandownerForm'),
                landowner: () => import('../editViews/Landowner'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Contact', value: 'contactId', table: 'contacts', form: () => import('../forms/ContactForm') },
                    { text: 'Is Public', value: 'isPublic' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    contacts: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "memberId", direction: "ascending" },
                    { column: "contactId", direction: "ascending" },
                ],
                itemsField: 'landowners',
                editPageName: 'landowner',
                apiMethod: 'Landowners',
                claimName: 'Landowners',
                formTitle: 'Landowner',
                excelTitle: 'Landowners',
                hasEditPage: true,
            }
        },
    };
</script>
